import { render, staticRenderFns } from "./WorkteamProcess.vue?vue&type=template&id=4f6b9976&scoped=true"
import script from "./WorkteamProcess.vue?vue&type=script&lang=js"
export * from "./WorkteamProcess.vue?vue&type=script&lang=js"
import "./WorkteamProcess.vue?vue&type=style&index=0&id=4f6b9976&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6b9976",
  null
  
)

export default component.exports